import { Injectable } from '@angular/core';
import { ScheduleHttpService } from "./https/schedule-http.service";
import { map, Observable } from "rxjs";
import { IResultSchedule, ResultSchedule } from "../../models/accounts/schedule.model";
import {EarningsApiResponse, EarningsData} from "../../models/dashboard/earnings.model";

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  constructor(private http: ScheduleHttpService) { }

  filter(wheres: { [key: string]: string }, limit: number = 100, offset: number = 0, sortField: string = '',
  sortOrder: 'asc' | 'desc' = 'asc',): Observable<ResultSchedule> {
    return this.http
      .filter(wheres, limit, offset, sortField, sortOrder)
      .pipe(
        map((notification: IResultSchedule) => ResultSchedule.fromObject(notification))
      );
  }
  bonusChartData(wheres: { [key: string]: string }): Observable<EarningsData[] > {
    return this.http
      .bonusChartData(wheres)
      .pipe(
        map((result: EarningsData[]) => result)
      );
  }

}
